export default __webpack_public_path__ + "static/media/blue2-small.f11698cb.png";